export const fonts = {
    title: 'Norse',
    dialog: 'Space Grotesk',
    ui: 'Futhark'
};
